<template>
  <form-container :header="translate('department.departments')" v-on:save="save" :disabled="loading">
    <div class="row">
      <div class="col col-limit">
        <div class="form-group">
          <label>{{translate('department.departmentName')}}</label>
          <input
            v-model="data.Name"
            type="text"
            class="form-control"
            required
            @input="checkInput('Name',$event)"
          />
        </div>
        <div class="form-group">
          <label>{{translate('department.description')}}</label>
          <!-- <textarea
            v-model="data.Description"
            type="text"
            class="form-control"
            maxlength="2000"
          ></textarea> -->
          <text-area-input v-model="data.Description" className="form-control" :maxlength="2000" />
        </div>
        <div class="form-group">
          <label>{{translate('login.email')}}</label>
          <input v-model="data.Email" @input="checkInput('Email',$event)" type="email" class="form-control" />
        </div>
        <div class="form-group">
          <label>
            <input type="checkbox" v-model="data.IsActive" />
            {{translate('department.departmentActive')}}
          </label>
        </div>
      </div>
      <div class="col-6">
        <h5>{{translate('department.departmentConnectedUsers')}}</h5>
        <select-multiple v-model="data.UserIds" :autocomplete="true" :list="userList" :getText="x => x.FullName" :emptyLabel="this.loadingLabel" class="user-select-input">
          <template slot-scope="{ item }">
              <div v-if="item" class="d-flex align-items-center">                                
                <img v-auth-image="item.ProfilePictureUrl" class="flow-picture" />
                <div class="d-flex w-100 justify-content-between">
                  <span>{{item.FullName}}</span>
                  <small class="text-right align-items-center">{{item.Title.Name}}</small>
                </div>
              </div>
              <div v-else>
                <span>{{translate('loading')}}</span>
              </div>
          </template>
        </select-multiple>
      </div>
    </div>
    <template v-slot:footer>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <button type="button" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
            </div>
            <div class="col text-right">
              <button type="submit" class="btn btn-success">{{translate('save')}}</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </form-container>
</template>

<script>
import formMixin from "../formMixin.js";
import formContainer from "../components/FormContainer.vue";
import TextAreaInput from '@/components/TextAreaInput.vue';
import selectMultiple from '../components/SelectMultiple.vue'

export default {
  mixins: [formMixin],
  components: {
    formContainer,
    TextAreaInput,
    selectMultiple
  },
  created() {
    this.getUsers({
      predicate: "IsActive= true",
      // DepartmentIds: [this.$route.params.id],
    }).then(x => {
      this.userList = x.Result;      
      this.loadingLabel = this.emptyLabel;
    });

    this.getData(this.$route.params.id, true, this.$route.query.kind);

  },
  methods:{
    checkInput(value, event) {
        // Check for invalid characters
        if (/[<>]/.test(event.target.value)) {
            alert(this.translate('errors.invalidSymbols'))
            const editedText = ""
            this.$set(this.data, value, editedText)
        } else {
            this.$set(this.data, value, event.target.value)
        }
    },
  },
  data() {
    return {
      loading: false,
      userList: null,
      modelName: "Department",
      emptyLabel: this.translate('emptyLabel'),
      loadingLabel: this.translate('listFetching'),
      data: {},
    };
  },
};
</script>
<style scoped>
.flow-picture {
    width:2.4em;
    height:2.4em;
    vertical-align:middle;
    margin-right:1rem;
    border-radius: 1.2em;
    float:left;
}
.user-select-input {
  max-height: 350px;
  height: 350px;;
}
</style>